/**
 * `-YYYYMMDDHHmm` in LOCAL time, for appending to an export's file name.
 *
 * Twelve digits, matching the requested example `202608310413` — which was
 * 04:13 Paris time, so the last four are hour and minute. (The request wrote
 * the pattern as `YYYYMMDDmmss`; minutes-and-seconds without an hour would
 * collide twice an hour and could not have produced `0413` at that moment, so
 * the example is taken as authoritative.)
 *
 * Local rather than UTC: this ends up in front of a person deciding which of
 * two downloads is the later one, and their own clock is the one they will
 * compare it against.
 */
export function exportTimestamp(now: Date = new Date()): string {
  const p = (n: number, width = 2) => String(n).padStart(width, '0');
  return (
    `${now.getFullYear()}` +
    p(now.getMonth() + 1) +
    p(now.getDate()) +
    p(now.getHours()) +
    p(now.getMinutes())
  );
}

/** `TrainingTool-annotated-202608310413.png` */
export function annotatedExportName(fileName: string, extension: string): string {
  const base = fileName.replace(/\.[^.]+$/, '') || 'document';
  return `${base}-annotated-${exportTimestamp()}.${extension}`;
}
